import Vue from 'vue'
import Router from 'vue-router'
import lobby from '@/components/lobby/index'





Vue.use(Router)

export default new Router({
	routes: [{
			path: '/',
			name: 'lobby',
			component: lobby,
			meta: {
				navShow: true
			},
		},




	]
})



// WEBPACK FOOTER //
// ./src/router/index.js